module.exports = __webpack_public_path__ + "static/media/injection.b5c75948.svg";